import { createAsyncThunk } from '@reduxjs/toolkit';
import { CreateReportingParameterRequest, UpdateReportingParameterRequest } from './types';
import api from 'src/app/api';
import { buildEncodedQueryString } from 'src/common';

export enum ReportingParametersActionType {
  CreateReportingParameter = '@@reporting/parameters/ReportParamCreateTemplate',
  UpdateReportingParameter = '@@reporting/parameters/ReportParamUpdateTemplate',
}

export enum ReportingParametersApi {
  CreateReportingParameter = '/reporting/ReportParamCreateTemplate',
  UpdateReportingParameter = '/reporting/ReportParamUpdateTemplate',
}

export const createReportingParameter = createAsyncThunk(
  ReportingParametersActionType.CreateReportingParameter,
  async (request: CreateReportingParameterRequest) => {
    const queryString = buildEncodedQueryString({
      kind: request.kind,
      afslId: request.afslId,
    });
    const response = await api.post<string>(`${ReportingParametersApi.CreateReportingParameter}${queryString}`, request.reportParameters);
    if (response.status !== 200) {
      return {
        message: 'Failed to create reporting parameters.',
        variant: 'error',
      };
    }
    return {
      message: 'Created new reporting parameters.',
      variant: 'success',
    };
  }
);

export const updateReportingParameter = createAsyncThunk(
  ReportingParametersActionType.UpdateReportingParameter,
  async (request: UpdateReportingParameterRequest) => {
    const queryString = buildEncodedQueryString({
      reportParameterId: request.reportParameterId,
      kind: request.kind,
      afslId: request.afslId,
    });
    const response = await api.post<string>(`${ReportingParametersApi.UpdateReportingParameter}${queryString}`, request.reportParameters);
    if (response.status !== 200) {
      return {
        message: 'Failed to create reporting parameters.',
        variant: 'error',
      };
    }
    return {
      message: 'Updated reporting parameters.',
      variant: 'success',
    };
  }
);
